module.exports = __webpack_public_path__ + "static/media/sunlink.e0bdd78e.gif";